<template>
    <v-layout align-start>
        <v-flex>
            <v-data-table 
            :headers="headers"
            :items="ProjectList"
            :search="search"texto
            sort-by="calories"
            class="elevation-1"
            v-if="verNuevo == 0"
            >

  
    
            <template v-slot:top>
                    <v-toolbar flat color="white">
                    <v-toolbar-title>ME SOP</v-toolbar-title>
                    <v-divider
                        class="mx-4"
                        inset
                        vertical
                    ></v-divider>                    
                    
                    <v-spacer></v-spacer>
                    <v-text-field class="text-xs-center"   v-if="verNuevo == 0" v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                   <!--<v-btn @click="listPartnoAlt()" color="primary" dark class="mb-2">Seach</v-btn> -->
                    
                    <v-spacer></v-spacer>
                    
                    <v-btn color="primary"  class="mb-2" @click="showNew" v-if="verNuevo == 0" dark >New item</v-btn>
                                                            
             

            </v-toolbar>
                 <template>                  
                    <v-row>
                        <v-dialog v-model="adModal" persistent max-width="290px">
                            <v-card>
                                <v-card-title class="headline" v-if="adAccion == 1">Active Item?</v-card-title>
                                <v-card-title class="headline" v-if="adAccion == 2">Desactive Item?</v-card-title>
                                <v-card-text>
                                    Are you sure to
                                    <span v-if="adAccion==1">Activate </span>
                                    <span v-if="adAccion==2">Deactivate </span>
                                    this WorkFlow: {{adName}} ?
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="green darken-1" text="text" @click="activateDesactivateClose">
                                        Cancel
                                    </v-btn>
                                    <v-btn v-if="adAccion==1" color="orange darken-4" text="text" @click="activate">
                                        Activate
                                    </v-btn>
                                    <v-btn v-if="adAccion==2" color="orange darken-4" text="text" @click="deactivate">
                                        Deactivate
                                    </v-btn>
                                    
                                </v-card-actions>
                            </v-card>
                        </v-dialog>

  
                         


                    </v-row>                    
                </template>
        </template>
               
                <template v-slot:body="{ items }">
                    <tbody>
                        <tr v-for="item in items" :key="item.id_doc">
                            <td>
                                <div >  
                                    <div >                                  
                                        <v-icon small class="mr-2" @click="editItem(item)">
                                            edit
                                        </v-icon>
                                       <!-- <template v-if="item.condition">
                                            <v-icon small class="mr-2" @click="activeDesactiveItem(2,item)">
                                                block
                                            </v-icon>
                                        </template>
                                        <template v-else="item.condition">
                                            <v-icon small class="mr-2" @click="activeDesactiveItem(1,item)">
                                                check
                                            </v-icon>
                                        </template>-->

                                    </div>
                                </div>                                                                                               
                            </td>                  
                                                        
                            <td class="text-xs-right">{{item.status}} </td>  
                            <td class="text-xs-right">{{item.sop_name}} </td> 

                            <td class="text-xs-right">{{item.platform}} </td>  
                            <td class="text-xs-right">{{item.model}} </td>   

                            <td class="text-xs-right">{{item.lob}} </td>  
                            <td class="text-xs-right">{{item.area}} </td>   

                            <td class="text-xs-right">{{item.line}} </td>  
                            <td class="text-xs-right">{{item.creator}} </td>                         
                            <td class="text-xs-right">{{moment(item.create_dt).format('MM/DD/YYYY HH:mm')}} </td>
                            <td class="text-xs-right">{{item.updater}} </td>                         
                            <td class="text-xs-right">{{moment(item.update_dt).format('MM/DD/YYYY HH:mm')}} </td>
                           
                            <!--<td class="text-xs-right">                                                        
                                <div v-if="item.condition">
                                    <span class="blue--text">Active</span>                                    
                                </div>
                                <div v-else>
                                <span class="red--text">Inactive</span>
                                </div>                                
                            </td>                        
                            <td class="text-xs-right">{{moment(item.create_dt).format('MM/DD/YYYY HH:mm')}} </td> -->                           

                        </tr>
                    </tbody>
                </template>
                     
                
                <template v-slot:no-data>
                    <v-btn color="primary" @click="initialize">Reset</v-btn>
                </template>
           </v-data-table>
           



         <v-container  grid-list-sm class="pa-4 white"  v-if="verNuevo"> 



  <!--Contact List Ini -->       
                       <v-dialog v-model="verContactos" persistent max-width="1000px"   >
                            <v-card>
                                <v-card-title> 
                                    <span class="headline">
                                        Select a contact 
                                    </span> 
                                </v-card-title>                            
                            
                                <v-card-text>


<!--DataTable ini-->
                                     <v-container  grid-list-sm class="pa-4 white" >              
                                        <v-layout row wrap>                  
                                        
                                            <v-flex xs12 sm12 md12 lg12 xl12>
                                                <v-text-field 
                                                append-icon="search" 
                                                class="text-xs-center"
                                                v-model="texto"
                                                label="Input contact name to search"
                                                @keyup.enter="listContact()"
                                                ></v-text-field>
                                                <template>
                                                    <v-data-table 
                                                        :headers="headersContact"
                                                        :items="contactos"
                                                        :search="search"                                                                                 
                                                        class="elevation-1"
                                                        >
                                                        <template v-slot:top>
                                                                <v-toolbar flat color="white"> 
                                                                <v-toolbar-title>Contact list</v-toolbar-title> 
                                                                <v-divider
                                                                    class="mx-4"
                                                                    inset
                                                                    vertical
                                                                ></v-divider>                  
                                                               
                                                      

                                                        </v-toolbar>
                                                        
                                                    </template>
                                                        
                                                            <template v-slot:body="{ items }">
                                                                <tbody>
                                                                    <tr v-for="item in items" :key="item.ID">
                                                                        <td >
                                                                            <div >  
                                                                                <div >                                  
                                                                                    <v-icon 
                                                                                    small 
                                                                                    class="mr-2"
                                                                                     @click="addContact(item)">
                                                                                        add
                                                                                    </v-icon>                                                       
                                                                                
                                                                                </div>
                                                                            </div>                                                                                               
                                                                        </td>                  

                                                                        <td class="text-xs-right">{{item.badgeid}} </td>
                                                                        <td class="text-xs-right">{{item.contactname}} </td> 
                                                                        <td class="text-xs-right">                                                
                                                                            <span class="blue--text"> {{item.email}} </span>                                          
                                                                        </td> 
                                                                                                
                                                                                                                                        
                                                                        <!--<td class="text-xs-right">{{moment(item.create_dt).format('MM/DD/YYYY HH:mm')}} </td> -->                          
                                                                    </tr>
                                                                </tbody>
                                                                
                                                            </template>
                                                                
                                                            <template v-slot:no-data>                                
                                                            <v-alert :value="true" color="error" icon="warning">
                                                                    Sorry, nothing to display here :(
                                                                </v-alert>
                                                            </template>
                                                            
                                                    </v-data-table>
                                                
                                                </template>

                                            </v-flex>

                                            <v-flex xs12 sm12 md12 lg12 xl12>
                                                <div class="red--text" v-for="v in validaMensaje" :key="v" v-text="v">  </div>
                                            </v-flex>


                                        </v-layout>             
                                     </v-container> 
<!--DataTable End -->

                                </v-card-text>

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn @click="hideContactList" color="blue darken" text>Cancel</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
<!--Contact list end -->








                <v-layout >  

                <template>
                    <v-container class="ma-0 pa-0" >
                    <v-dialog v-model="verMessageBackend" persistent max-width="290px">
                            <v-card>
                                <v-card-title class="headline">Project duplicate</v-card-title>                               
                                <v-card-text>                                   
                                    <span> Go to main screen for edit this project. </span>                                   
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="green darken-1" text="text" @click="messageBackendClose">
                                        Cancel
                                    </v-btn>                                    
                                    
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                        <v-row                    
                        no-gutters
                        >
                        <v-col   lg="3"                      
                        >
                            <v-card  
                            class="pa-2"                            
                            tile
                            >
                            <v-flex xs12 sm12 md12 lg12 xl12>
                                <v-text-field v-model="frmProjectName"  label="Project name"> </v-text-field>
                            </v-flex>
                            <v-container >
                                <v-row                       
                                no-gutters
                                >
                                    <v-col   lg="12">
                                       <v-flex xs12 sm12 md12 lg12 xl12>
                                            <v-text-field @keyup.enter="findPlatformAndModel()"
                                            :disabled="dialogLoading"
                                            :loading="dialogLoading"
                                             v-model="frmServiceTag" 
                                              label="Service tag"> </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm12 md12 lg12 xl12>
                                            <v-text-field v-model="frmServiceTagPlaform" 
                                             label="Platform" filled readonly> </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm12 md12 lg12 xl12>
                                            <v-text-field v-model="frmServiceTagModel" 
                                             label="Model"  filled readonly> </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm12 md12 lg12 xl12>
                                            <v-select v-model="frmIdLob" 
                                            :items="lobItems" 
                                            item-text="lob"
                                            item-value="id_lob"
                                            label="LOB"> </v-select>
                                        </v-flex>	
                                        <v-flex xs12 sm12 md12 lg12 xl12>
                                            <v-select v-model="frmIdArea" 
                                            :items="areaItems" 
                                            item-text="area"
                                            item-value="id_area"
                                            label="Area"> </v-select>
                                        </v-flex>	
                                        <v-flex xs12 sm12 md12 lg12 xl12>
                                            <v-select v-model="frmIdLinetype" 
                                            :items="lineItems" 
                                            item-text="linetype"
                                            item-value="id_line"
                                            label="Line type"> </v-select>
                                        </v-flex>                                         
                                        <v-flex xs12 sm12 md12 lg12 xl12>                                
                                            <v-select v-model="frmIdWorkflow" 
                                            :items="workflowItems" 
                                            item-text="flowname"
                                            item-value="id_flow"
                                            :readonly = "frmFlownameIsReadOnly"
                                            label="Workflow"> </v-select>
                                        </v-flex>
                                       
                                    </v-col>
                                    <v-col lg="3" >
                                        <v-btn 
                                        @click="hideNew()"  
                                        color="blue darken-1" text>Close</v-btn>
                                    </v-col>
                                     <v-col lg="3" >
                                            <v-btn 
                                            :disabled="dialogLoadingSaveProject"
                                            :loading="dialogLoadingSaveProject"
                                        @click="save()"
                                        color="success" >Save</v-btn>
                                         <v-dialog
                                                v-model="dialogLoadingSaveProject"
                                                hide-overlay
                                                persistent
                                                width="300"
                                                >
                                                    <v-card
                                                        color="primary"
                                                        dark
                                                    >
                                                        <v-card-text>
                                                        Saving, please be patient.
                                                            <v-progress-linear
                                                                indeterminate
                                                                color="white"
                                                                class="mb-0"
                                                            ></v-progress-linear>
                                                        </v-card-text>
                                                    </v-card>
                                            </v-dialog>     
                                    </v-col  >
                                    </v-row>
                            </v-container>
                            </v-card>
                        </v-col>
                        <v-col
                           lg="9"
                        >
                            <v-card
                            class="pa-2"
                            
                            tile
                            >

                             <v-flex xs12 sm12 md12 lg12 xl12>
                        <div class="red--text" v-for="v in validaMensaje" :key="v" v-text="v">  </div>
                     </v-flex>
                     <v-flex xs12 sm12 md12 lg12 xl12>                                                
                        <v-data-table 
                            :headers="headersDetail"
                            :items="sopFiles"
                            :search="searchStation"
                                                    
                            class="elevation-1"
                            >
                            <template v-slot:top>
                                    <v-toolbar flat color="white"> 
                                    <v-toolbar-title>Stations</v-toolbar-title> 
                                    <v-divider
                                        class="mx-4"
                                        inset
                                        vertical
                                    ></v-divider>                    
                                       
                                    <v-text-field class="text-xs-center" 
                                    v-model="searchStation" append-icon="search" 
                                    label="Search" single-line hide-details></v-text-field>

                                      

                            <template>
                                    <v-row justify="center">
                                        <v-dialog v-model="dialog" persistent max-width="900px">                                      
                                        <v-card>
                                            <v-card-title>
                                            <span class="headline">{{ formTitle }}</span>
                                            </v-card-title> 

                                        
                                            <v-card-text>                            
                                            <v-container>                              
                                                <v-flex xs12 sm12 md12 lg12 xl12>
                                                    <div class="red--text" v-for="v in validaMensaje" :key="v" v-text="v">  </div>
                                                </v-flex>   
                                                <v-row>
                                                
                                                    <v-col cols="12" sm="6" md="4">
                                                        <v-text-field v-model="flowname" label="Flow Name" required></v-text-field>
                                                    </v-col>                                                                                                     
                                                                                                                
                                                </v-row>                            
                                            </v-container>
                                            <small>*indicates required field</small>
                                            </v-card-text>
                                            <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>                            
                                                <v-btn
                                                    :disabled="dialogLoadingSaveProject"
                                                    :loading="dialogLoadingSaveProject"
                                                    color="blue darken-1" text @click="save"
                                                    >
                                                    Save
                                                </v-btn>
                                            
                                                
                                        
                                        <v-dialog
                                                v-model="dialogLoading"
                                                hide-overlay
                                                persistent
                                                width="300"
                                                >
                                                    <v-card
                                                        color="primary"
                                                        dark
                                                    >
                                                        <v-card-text>
                                                        Saving, please be patient.
                                                        <v-progress-linear
                                                            indeterminate
                                                            color="white"
                                                            class="mb-0"
                                                        ></v-progress-linear>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-dialog>            

                                            </v-card-actions>
                                        </v-card>
                                        </v-dialog>
                                    </v-row>
                                
                                
                                
                                </template>
                                                                     
                                
                                <v-btn color="primary" @click="addNewStation()" v-if="projectID_new > 0"
                                    :disabled="dialogLoadingSaveNewStation"
                                    :loading="dialogLoadingSaveProject"
                                    >New</v-btn>
                                 <v-dialog
                                                v-model="dialogLoadingSaveNewStation"
                                                hide-overlay
                                                persistent
                                                width="300"
                                                >
                                                    <v-card
                                                        color="primary"
                                                        dark
                                                    >
                                                        <v-card-text>
                                                        Saving, please be patient.
                                                            <v-progress-linear
                                                                indeterminate
                                                                color="white"
                                                                class="mb-0"
                                                            ></v-progress-linear>
                                                        </v-card-text>
                                                    </v-card>
                                            </v-dialog>  
                                 

                          
                          
                            </v-toolbar>
                            
                        </template>
                             
                                <template v-slot:body="{ items }">
                                    <tbody>
                                        <tr v-for="item in items" :key="item.id_doc_det">
                                            <td>
                                                <div >  
                                                  <div v-if="item.sop.length == 0">
                                                        <div >                                                                                                                                               
                                                            <v-icon small class="mr-2" @click="ShowDeleteStation(item)"> <!-- @click="editItem(item)"> -->
                                                                delete
                                                            </v-icon>                                                      
                                                        </div>
                                                    </div>
                                                    <div v-if="item.sop.length > 0">
                                                        <div >   
                                                        <v-icon small class="mr-2" @click="collectionsShow(item)">
                                                                collections
                                                            </v-icon>   
                                                             <v-icon small v-if="item.sop[0].signList.length > 0"
                                                             class="mr-2" @click="signaturesShow(item)">
                                                                person
                                                            </v-icon>                                                                                  
                                                            <v-icon small class="mr-2"  @click="ShowDeleteStation(item)"> 
                                                                delete
                                                            </v-icon>                                                      
                                                        </div>
                                                    </div>

                                                    




                                                </div>                                                                                               
                                            </td>                  
                                            <!--{station:'1',sop:'ppt', status:'Development',currentstatus:'Development',upload:'' },-->
                                            <td class="text-xs-right">
                                                 <v-text-field  
                                                filled
                                                rounded
                                                dense
                                                type="number" v-model="item.station_no"></v-text-field>
                                            </td>

                                            <td class="text-xs-right">
                                                <div v-if="item.sop.length > 0">
                                                    <v-icon small class="mr-2" color="blue" 
                                                    @click="downloadPowerPoint(item)">
                                                            cloud_download
                                                    </v-icon>

                                                </div> 
                                            </td>
                                            
                                            <td class="text-xs-right">
                                              <div v-if="item.status == 'Development'">
                                                <v-chip color="#D6D5D5" >{{item.status}}</v-chip>
                                              </div>                                                     
                                              <div v-if="item.status == 'Validating'">
                                                <v-chip color="#AEAEAE"  >{{item.status}}</v-chip>
                                              </div>  
                                              <div v-if="item.status == 'Approving'">
                                                <v-chip color="#696868" dark >{{item.status}}</v-chip>
                                              </div>  
                                              <div v-if="item.status == 'Rejected'">
                                                <v-chip color="#FA8072" dark >{{item.status}}</v-chip>
                                              </div> 
                                              <div v-if="item.status == 'Canceled'">
                                                <v-chip color="#CD5C5C" dark >{{item.status}}</v-chip>
                                              </div> 
                                             <div v-if="item.status == 'Approved'">
                                                <v-chip color="#EAF9B3" >{{item.status}}</v-chip>
                                              </div>
                                              <div v-if="item.status == 'Promoted'">
                                                <v-chip color="#D6FB4F" >{{item.status}}</v-chip>
                                              </div>

                                                
                                                                                      
                                            </td>                                                                        
                                            <td class="text-xs-right">                                              
                                                 <div v-if="item.status == '' 
                                                        || item.status == 'Development'                                                        
                                                        || item.status == 'Promoted'">
                                                    <v-file-input 
                                                        v-model= "item.upload"                                     
                                                        accept=".pptx"
                                                        placeholder="SOP file"                                        
                                                        label="File"
                                                        :disabled="dialogLoadingUploadFile"                                                        
                                                    ></v-file-input> 
                                                </div>   
                                                <div v-if="item.status == 'Rejected'
                                                        || item.status == 'Canceled'">
                                                     <span class="red--text"> {{item.msg}} </span>  
                                                </div>                    
                                             </td> 
                                             <td class="text-xs-right">
                                             <div v-if="item.upload != null">
                                                    <v-btn color="#FBF703" @click="uploadPowerPoint(item)"
                                                    :disabled="dialogLoadingUploadFile"                                                    
                                                    >Upload</v-btn>
                                                    <v-dialog
                                                        v-model="dialogLoadingUploadFile"
                                                        hide-overlay
                                                        persistent
                                                        width="300"
                                                        >
                                                            <v-card
                                                                color="primary"
                                                                dark
                                                            >
                                                                <v-card-text>
                                                                We are processing you request, please be patient.
                                                                    <v-progress-linear
                                                                        indeterminate
                                                                        color="white"
                                                                        class="mb-0"
                                                                    ></v-progress-linear>
                                                                </v-card-text>
                                                            </v-card>
                                                    </v-dialog>  
                                            </div>
                                                <div v-if="item.status == 'Development' && item.sop.length > 0">                                                                                
                                                    <v-btn color="#D1D1D1" @click="sendToWorkflow(item)" 
                                                     :disabled="dialogLoadingUploadFile" 
                                                    >workflow</v-btn>
                                                </div>
                                                <div v-if="item.status == 'Approved'">
                                                    <v-btn color="#03ECFB" @click="promoted(item)" 
                                                    :disabled="dialogLoadingUploadFile"
                                                    >
                                                    Delivery</v-btn>
                                                </div>
                                                 <div v-if="item.status == 'Validating'
                                                        || item.status == 'Approving'">
                                                    <v-btn color="#C18AFE" @click="stopWorkflow(item)" 
                                                    :disabled="dialogLoadingUploadFile" 
                                                    >stop</v-btn> 
                                                 </div>
                                                 <div v-if="item.status == 'Rejected'
                                                    || item.status == 'Canceled'">
                                                    <v-btn color="#FE8AE2"  
                                                     @click="stopWorkflow(item)" 
                                                    :disabled="dialogLoadingUploadFile" 
                                                    >Reset</v-btn>
                                                 </div>
                                            </td>                                                                      
                                           
                                                                       
                                                                                                            
                                            <!--<td class="text-xs-right">{{moment(item.create_dt).format('MM/DD/YYYY HH:mm')}} </td> -->                          
                                        </tr>
                                    </tbody>
                                    
                                </template>
                                    
                                <template v-slot:no-data>                                
                                   <v-alert :value="true" color="error" icon="warning">
                                        Sorry, nothing to display here :(
                                    </v-alert>
                                </template>
                                
                        </v-data-table>

                    </v-flex>

                   
                    
                    </v-card>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-dialog v-model="dialogShowImages" persistent max-width="1000px"   >
                            <v-card>
                            <v-toolbar
                                color="indigo"
                                dark
                                >                              
                                <v-toolbar-title>Station: {{stationCarrusel}}</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn icon>
                                    <v-icon @click="collectionsHide">close</v-icon>
                                </v-btn>
                                </v-toolbar>                                                
                                <v-card-text>

                                    <v-container  grid-list-sm class="pa-4 white" >              
                                        <v-layout row wrap>                
                                        
                                        <v-flex xs12 sm12 md12 lg12 xl12>
                                                <v-card
                                                elevation="24"
                                                max-width="85%"
                                                class="mx-auto"
                                            >
                                                <v-system-bar lights-out></v-system-bar>

                                            <v-carousel
                                                cycle
                                                height="100%"
                                                
                                                show-arrows-on-hover
                                                :cycle="cycle"
                                                v-model="model"
                                            >                                                                       

                                                <v-carousel-item
                                                v-for="(item,i) in itemsSOP"
                                                :key="i"
                                                >                                                                       
                                                    <v-row
                                                    class="fill-height"
                                                    align="center"
                                                    justify="center"
                                                    >                                                                        
                                                    <v-img
                                                        :src="item.img_path"
                                                        height="100%"
                                                        class="grey darken-4"
                                                        ></v-img>
                                                    
                                                    </v-row>                                                                        
                                                </v-carousel-item> 
                                            </v-carousel>
                                            </v-card>

                                        </v-flex>
                                                <template>                                              
                                                
                                                </template>
                                        </v-layout>             
                                    </v-container> 


                                </v-card-text>

                                <v-card-actions>
                                    <v-spacer></v-spacer>                                                            
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-row>

                    <v-row>
                        <v-dialog v-model="dialogShowSignatures" persistent max-width="1200px"   >
                            <v-card>
                            <v-toolbar
                                color="indigo"
                                dark
                                >                              
                                <v-toolbar-title>Station: {{stationSignatures}}</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn icon>
                                    <v-icon @click="signaturesHide">close</v-icon>
                                </v-btn>
                                </v-toolbar>                                                
                                <v-card-text>

                                    <v-container  grid-list-sm class="pa-4 white" >              
                                        <v-layout row wrap>                
                                        
                                        <v-flex xs12 sm12 md12 lg12 xl12>
                                          
                                            <!--DataTable here-->
                                         <v-data-table 
                                            :headers="headersSignatures"
                                            :items="DetailsSignatures"                            
                                            hide-default-footer                          
                                            class="elevation-1"
                                            >
                                            <template v-slot:top>
                                                    <v-toolbar flat color="white"> 
                                                    <v-toolbar-title>Signatures</v-toolbar-title> 
                                                        <v-divider
                                                            class="mx-4"
                                                            inset
                                                            vertical
                                                        ></v-divider>                 
                                                    </v-toolbar>                                            
                                            </template>
                                            
                                                <template v-slot:body="{ items }">
                                                    <tbody>
                                                        <tr v-for="item in items" :key="item.ID">
                                                                        

                                                            
                                                            <td class="text-xs-right">{{item.send_sequence}} </td>                                                            
                                                            <td class="text-xs-right">                                                        
                                                                <div v-if="item.send_date != null">
                                                                    <span class="blue--text">{{moment(item.send_date).format('MM/DD/YYYY HH:mm')}}</span>                                    
                                                                </div>
                                                                <div v-else>
                                                                <span class="red--text">-----</span>
                                                                </div>                                
                                                            </td>                                                                     
                                                            <td class="text-xs-right">
                                                                <div v-if="item.contactType == 'Validator'">
                                                                    <v-chip color="purple" dark>{{item.contactType}}</v-chip>                                                                                    
                                                                </div>
                                                                <div v-if="item.contactType == 'Approver'">                                                   
                                                                    <v-chip color="orange" dark>{{item.contactType}}</v-chip>                                  
                                                                </div>                                              
                                                            </td>
                                                            
                                                            <td class="text-xs-right">{{item.contactname}} </td> 
                                                            <td class="text-xs-right">                                                
                                                                <span class="blue--text"> {{item.email}} </span>                                          
                                                            </td>                                                            
                                                            <td class="text-xs-right">                                                        
                                                                <div v-if="item.is_sign">
                                                                    <span class="blue--text">Yes</span>                                    
                                                                </div>
                                                                <div v-else>
                                                                <span class="red--text">-----</span>
                                                                </div>                                
                                                            </td>   
                                                           
                                                            <td class="text-xs-right">                                                        
                                                                <div v-if="item.sign_dt != null">
                                                                    <span class="blue--text">{{moment(item.sign_dt).format('MM/DD/YYYY HH:mm')}}</span>                                    
                                                                </div>
                                                                <div v-else>
                                                                <span class="red--text">-----</span>
                                                                </div>                                
                                                            </td>    
                                                            <td class="text-xs-right">{{item.comments}} </td>                                                            
                                                            <!--<td class="text-xs-right">{{moment(item.create_dt).format('MM/DD/YYYY HH:mm')}} </td> -->                          
                                                        </tr>
                                                    </tbody>
                                                    
                                                </template>
                                                    
                                                <template v-slot:no-data>                                
                                                <v-alert :value="true" color="error" icon="warning">
                                                        Sorry, nothing to display here :(
                                                    </v-alert>
                                                </template>
                                                
                                        </v-data-table>
                                       
                                       
                                        </v-flex>
                                                <template>                                              
                                                
                                                </template>
                                        </v-layout>             
                                    </v-container> 


                                </v-card-text>

                                <v-card-actions>
                                    <v-spacer></v-spacer>                                                            
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-row>
                   
                        <v-row>   <!--Confirmar borrado de estacion-->
                                <v-dialog v-model="adModal" persistent max-width="350px">
                                <v-card>
                                    <v-card-title class="headline" >Delete Station?</v-card-title>
                                   <!-- <v-card-title class="headline" v-if="adAccion == 2">Desactive Item?</v-card-title>-->
                                    <v-card-text>
                                        Are you sure to delete the station# {{adName}} ?                                       
                                        
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="green darken-1" text="text" @click="HideDeleteStation()">
                                            Cancel
                                        </v-btn>
                                        <v-btn  color="orange darken-4" text="text" @click="deleteStation()">
                                            Delete
                                        </v-btn>
                                        
                                        
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                            </v-row>
                   
                    </v-container>
                </template>               
                                  
                 

                </v-layout>             
           </v-container> 
 
        
                 
            

        </v-flex>

    
    </v-layout>  


    

</template>

  
        
        
        


<script>    
    import axios from 'axios'; 
    import moment from 'moment'; 
   
    export default{
        components: {
                     
        },       
        data (){
            return {
                  moment:moment,                
                  partnoAlt:[],                  
                  dialog: false,
                  dialogShowImages:false,
                  dialogShowSignatures:false,
                  dialogLoading: false,
                  dialogLoadingSaveProject: false,
                  dialogLoadingSaveNewStation: false,
                  dialogLoadingUploadFile: false,
                    headers: [
                        { text: 'Actions', value: 'action', sortable: false },                        
                       // { text: 'ID', value: 'id', sortable: false },
                        { text: 'Status', value: 'status', sortable: true }, 
                        { text: 'Project Name', value: 'sop_name', sortable: true }, 
                        { text: 'Platform', value: 'platform', sortable: true }, 
                        { text: 'Model', value: 'model', sortable: true }, 
                        { text: 'LOB', value: 'lob', sortable: true }, 
                        { text: 'Area', value: 'area', sortable: true }, 
                        { text: 'Line Type', value: 'line', sortable: true }, 
                        { text: 'Creator', value: 'creator', sortable: true },                                               
                        { text: 'CreateDate', value: 'create_dt', sortable: true },
                        { text: 'Updater', value: 'updater', sortable: true }, 
                        { text: 'UpdateDate', value: 'update_dt', sortable: true }                       
                    ],
                     headersDetail: [
                        { text: 'Action', value: 'action', sortable: false },       
                        { text: '#Station', value: 'station_no', sortable: false },                 
                        { text: 'Download', value: 'sop', sortable: false },
                        { text: 'Status', value: 'status', sortable: false },                                                                    
                        { text: 'Upload', value: 'upload', sortable: false },                                          
                    ],
                     headersSignatures: [                              
                        { text: '#Step', value: 'send_sequence', sortable: false },                 
                        { text: 'Send date', value: 'send_date', sortable: false }, 
                        { text: 'Contact type', value: 'contactType', sortable: false },
                        { text: 'Name', value: 'contactname', sortable: false },
                        { text: 'Email', value: 'email', sortable: false },                                               
                        { text: 'Signature', value: 'is_sign', sortable: false },
                        { text: 'Signature date', value: 'sign_dt', sortable: false },
                        { text: 'Comments', value: 'comments', sortable: false }                         
                    ],
                    
                    ProjectList:[
                    ],
                    currentProject: [],               
                    DetailsContact: [
                        ],
                    DetailsSignatures: [
                        ],
                    
                    //moment: moment, // Set to whatever
                    //privileges: false,
                    search: '',
                    searchStation:'',
                    desserts: [],
                    editedIndex: -1,
                    
                    model: 0,
                    cycle: false,
                    stationCarrusel:'',
                    stationSignatures:'',
                    itemsSOP: [                       
                        ],

                    verNuevo:0,
                    errorContact: null,

                    
                    
                    
                    projectID_new: 0,
                    detailID_remove:0,
                   
                    frmFlownameIsReadOnly: true,
                    frmFlowname: '',
                    frmProjectName:'',
                    frmContactType: 'Validator', 
                    frmIdArea:'',
                    frmIdLob:'',
                    frmIdLinetype:'',
                    frmIdWorkflow:'',                    
                    frmServiceTag:'', 
                    frmServiceTagPlaform: '',
                    frmServiceTagModel: '',

                    serviceTagItems:[],
                    lobItems: [],
                    areaItems: [],
                    lineItems: [],
                    workflowItems: [],
                    NumberStationItems: ['1','2','3','4','5','6','7','8','9','10'
                    ,'11','12','13','14','15','16','17','18','19','20'
                    ,'21','22','23','24','25','26','27','28','29','30'
                    ,'31','32','33','34','35','36','37','38','39','40'],
                    frmContactBadgeid: '',

                    verMessageBackend:0,                   

                    id: '', 
                    part_number: '', 
                    part_number_alt: '', 
                    create_dt: '', 


                    verContactos:0,

                    sopFiles: [],
                    /*sopFiles:[
                         {station_no:'1',sop:'', status:'',upload:null,msg:'' },
                         {station:'2',sop:'ppt', status:'Development',upload:null,msg:'' },
                         {station:'3',sop:'ppt', status:'Validating',upload:null,msg:'' },
                         {station:'4',sop:'ppt', status:'Approving',upload:null,msg:'' },
                         {station:'5',sop:'ppt', status:'Rejected',upload:null,msg:'It was rejected because the emsable procedure is badly defined.' },
                         {station:'6',sop:'ppt', status:'Canceled',upload:null,msg:'It was cancelled to rebalance the stations.' },
                         {station:'7',sop:'ppt', status:'Approved',upload:null,msg:'' },
                         {station:'8',sop:'ppt', status:'Promoted',upload:null,msg:'' },
                         {station:'9',sop:'ppt', status:'Development',upload:null,msg:'' },
                         {station:'10',sop:'ppt', status:'Development',upload:null,msg:'' },
                         {station:'11',sop:'ppt', status:'Development',upload:null,msg:'' },
                         {station:'12',sop:'ppt', status:'Development',upload:null,msg:'' },
                         {station:'13',sop:'ppt', status:'Development',upload:null,msg:'' },
                         {station:'14',sop:'ppt', status:'Development',upload:null,msg:'' },
                         {station:'15',sop:'ppt', status:'Development',upload:null,msg:'' },
                         {station:'16',sop:'ppt', status:'Development',upload:null,msg:'' },
                         {station:'17',sop:'ppt', status:'Development',upload:null,msg:''},
                         {station:'18',sop:'ppt', status:'Development',upload:null,msg:'' },
                         {station:'19',sop:'ppt', status:'Development',upload:null,msg:'' },
                         {station:'20',sop:'ppt', status:'Development',upload:null,msg:'' },
                         {station:'21',sop:'ppt', status:'Development',upload:null,msg:'' },
                         {station:'22',sop:'ppt', status:'Development',upload:null,msg:'' },
                         {station:'23',sop:'ppt', status:'Development',upload:null,msg:'' },
                         {station:'24',sop:'ppt', status:'Development',upload:null,msg:''},
                         {station:'25',sop:'ppt', status:'Development',upload:null,msg:'' },

                    ],*/

                    headersContact:[
                        { text: 'Select', value: 'select', sortable: false },                        
                        { text: 'Badgeid', value: 'badgeid', sortable: false },
                        { text: 'Name', value: 'contactname' },
                        { text: 'Email', value: 'email', sortable: false }                      
                    ],

                    file: null,

                   texto: '',            
                   contactos: [],

                    valida:0,
                    validaMensaje:[],

                    adModal: 0,
                    adAccion: 0, 
                    adName: '',
                    adId: '',  

                    flowname: ''
                                
            }   
        },
        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'New Contact' : 'Edit Contact'
            },
                          
        },

        watch: {
            dialog (val) {
            val || this.close()
            } ,
             dialogLoading (val)  {
                if (!val) return
            }          
        },

        created () {
            this.initialize();
            this.listProject();
            this.listWorkflow();
            this.listLOB();
            this.listArea();
            this.listLinetype();          
            //this.havePriviges();     
        },

         methods: { 
           //   havePriviges() {
            //    this.$store.state.user.rol === "yms_customs" ? this.privileges =false : this.privileges =true
            //} ,  
            messageBackendClose(){
                this.verMessageBackend = 0;
            },

            ShowDeleteStation(item){
                this.adModal = true; 
                this.adName = item.station_no;
                this.detailID_remove = item.id_doc_det;
            },
            HideDeleteStation(){
                this.adModal = false;
                this.adName = '';
                this.detailID_remove = 0;
            },
            

            deleteStation(){                
                                  
                 let me=this; 
                    let header={
                        "x-token": this.$store.state.token,
                        "Authorization": "Bearer " + this.$store.state.token                       
                        };   
                    //let header={"Authorization": "Bearer " + this.$store.state.token};
                    let configuration = {headers : header };
                    this.dialogLoadingSaveNewStation = true;        


                    axios.post('api/dell_sop_d_document_detail/DeleteDocumentDetail',{                                                   
                            'id_doc':  me.projectID_new,
                            'id_doc_det': me.detailID_remove     
                    },configuration).then(function(response){
                        
                        me.listCurrentProject();
                        //me.adName = '';
                        //me.detailID_remove = 0;
                         me.HideDeleteStation();
                        
                        if (response.data.msg == 'Token no valid')
                        {
                            me.exitApp();
                        }
                    }).catch(function(error){                     
                       console.log(error);
                    }).finally(() => this.dialogLoadingSaveNewStation  = false,                        
                        //this.validaMensaje.push('Area is already registered.')
                    ); 

                //}
            },  
             addNewStation(){
               
                    if (this.validarNewStation() > 0)  {                                      
                     return;   
                }  
                    var sendSequence = 0;
                    sendSequence  = this.sopFiles.length +1;

                  
                 let me=this; 
                    let header={
                        "x-token": this.$store.state.token,
                        "Authorization": "Bearer " + this.$store.state.token                       
                        };   
                    //let header={"Authorization": "Bearer " + this.$store.state.token};
                    let configuration = {headers : header };
                    this.dialogLoadingSaveNewStation = true;         
                    axios.post('api/dell_sop_d_document_detail/CreateDocumentDetail',{                                                   
                            'id_doc':  me.projectID_new,
                            'station_no': sendSequence     
                    },configuration).then(function(response){
                        //console.log('Save');
                        //me.close();
                        me.listCurrentProject();
                        //me.listProject();                       
                       
                        //me.clean();
                        if (response.data.msg == 'Token no valid')
                        {
                            me.exitApp();
                        }
                    }).catch(function(error){                     
                       console.log(error);
                    }).finally(() => this.dialogLoadingSaveNewStation  = false,
                        //this.validaMensaje.push('Area is already registered.')
                    ); 

                //}
             },
             findPlatformAndModel(){                
                this.dialogLoading = true;
                let me=this;
                me.frmServiceTagPlaform =  '';
                me.frmServiceTagModel =  ''; 
                let header={"Authorization": "Bearer " + this.$store.state.token};
                let configuration = {headers : header };
                let url='';
                url ='api/dell_sop_d_document_master/findPlatformAndModel/' + me.frmServiceTag;               
                axios.get(url,configuration).then(function(response){  
                    //console.log(response.data);               
                    me.serviceTagItems = response.data;
                    me.frmServiceTagPlaform =  response.data.platform;
                    me.frmServiceTagModel =  response.data.model; 
                                     
                }).catch(function(error){
                    console.log(error);
                }).finally(() => this.dialogLoading  = false,                        
                    ); 
             },
             listProject(){
                let me=this;
                let header={"Authorization": "Bearer " + this.$store.state.token};
                let configuration = {headers : header };
                let url='';
                url ='api/dell_sop_d_document_master/List';               
                axios.get(url,configuration).then(function(response){                   
                    me.ProjectList = response.data;
                    console.log(me.ProjectList);
                }).catch(function(error){
                    console.log(error);
                })
            },
              listCurrentProject(){
                let me=this;
                let header={"Authorization": "Bearer " + this.$store.state.token};
                let configuration = {headers : header };
                let url='';
                url ='api/dell_sop_d_document_master/CurrentProject/'+ me.projectID_new;  
                console.log(url);             
                axios.get(url,configuration).then(function(response){   
                    me.currentProject = response.data; 
                    me.sopFiles = me.currentProject[0].detail;
                    console.log(me.currentProject[0]);
                     console.log(me.sopFiles);           
                }).catch(function(error){
                    console.log(error);
                })
            },
             listLOB(){
                let me=this;
                let header={"Authorization": "Bearer " + this.$store.state.token};
                let configuration = {headers : header };
                let url='';
                url ='api/dell_sop_s_lob/ActiveList';               
                axios.get(url,configuration).then(function(response){                   
                    me.lobItems = response.data;
                }).catch(function(error){
                    console.log(error);
                })
            },
            listArea(){
                let me=this;
                let header={"Authorization": "Bearer " + this.$store.state.token};
                let configuration = {headers : header };
                let url='';
                url ='api/dell_sop_s_area/ActiveList';               
                axios.get(url,configuration).then(function(response){                   
                    me.areaItems = response.data;
                }).catch(function(error){
                    console.log(error);
                })
            },
            listLinetype(){                 
                let me=this;
                let header={"Authorization": "Bearer " + this.$store.state.token};
                let configuration = {headers : header };
                let url='';
                url ='api/dell_sop_s_line_type/ActiveList';               
                axios.get(url,configuration).then(function(response){                   
                    me.lineItems = response.data;
                }).catch(function(error){
                    console.log(error);
                })
            },
             listWorkflow(){                
                let me=this;
                let header={"Authorization": "Bearer " + this.$store.state.token};
                let configuration = {headers : header };
                let url='';
                url ='api/dell_sop_s_workflow_master/ActiveList';               
                axios.get(url,configuration).then(function(response){                   
                    me.workflowItems = response.data;
                }).catch(function(error){
                    console.log(error);
                })
            },
            uploadPowerPoint(item){                

                let me=this;    
                    let header={
                        "x-token": this.$store.state.token,
                        "Authorization": "Bearer " + this.$store.state.token,
                        "Content-Type": "multipart/form-data"
                        };
                    let configuration = {headers : header };
                    this.dialogLoadingUploadFile = true;  

                    let formData = new FormData();                   
                    formData.append("id_doc", me.projectID_new);
                    formData.append("platform", me.frmServiceTagPlaform);
                    formData.append("model", me.frmServiceTagModel);
                    formData.append("id_area", me.frmIdArea);
                    formData.append("id_line", me.frmIdLinetype);
                    formData.append("id_doc_det", item.id_doc_det);                      
                    formData.append("file", item.upload);  
                                
                   axios.post('api/dell_sop_d_document_master/UploadPowerPoint',formData,configuration).then(function(response){                      
                        //me.close();                                         
                        //me.listInvoices();
                        //me.clean();
                        item.upload = null;
                        if (response.data.msg == 'Token no valid')
                        {
                            me.exitApp();
                        }                       
                         me.listCurrentProject();
                    }).catch(function(error){                     
                       console.log(error);
                    }).finally(() => this.dialogLoadingUploadFile  = false,                        
                    ); 

            },
            sendToWorkflow(item){
                let me=this;    
                    let header={
                        "x-token": this.$store.state.token,
                        "Authorization": "Bearer " + this.$store.state.token,
                        "Content-Type": "multipart/form-data"
                        };
                    let configuration = {headers : header };
                    this.dialogLoadingUploadFile = true;  

                    let formData = new FormData();                   
                    formData.append("id_doc", me.projectID_new);
                    formData.append("id_doc_det", item.id_doc_det);
                    formData.append("id_flow", me.frmIdWorkflow);
                    
              

              
                   axios.post('api/dell_sop_d_document_detail/WorkflowStart',formData,configuration).then(function(response){                     
                        if (response.data.msg == 'Token no valid')
                        {
                            me.exitApp();
                        }                       
                         me.listCurrentProject();
                    }).catch(function(error){                     
                       console.log(error);
                    }).finally(() => this.dialogLoadingUploadFile  = false,                        
                    ); 
            },
            promoted(item){
                 let me=this;    
                    let header={
                        "x-token": this.$store.state.token,
                        "Authorization": "Bearer " + this.$store.state.token,
                        "Content-Type": "multipart/form-data"
                        };
                    let configuration = {headers : header };
                    this.dialogLoadingUploadFile = true;  

                    let formData = new FormData();                   
                    formData.append("id_doc", me.projectID_new);
                    formData.append("id_doc_det", item.id_doc_det);
                    formData.append("id_flow", me.frmIdWorkflow);
                    

                   axios.post('api/dell_sop_d_document_detail/Promoted',formData,configuration).then(function(response){                     
                        if (response.data.msg == 'Token no valid')
                        {
                            me.exitApp();
                        }                       
                         me.listCurrentProject();
                    }).catch(function(error){                     
                       console.log(error);
                    }).finally(() => this.dialogLoadingUploadFile  = false,                        
                    ); 
            },
            stopWorkflow(item){
                 let me=this;    
                    let header={
                        "x-token": this.$store.state.token,
                        "Authorization": "Bearer " + this.$store.state.token,
                        "Content-Type": "multipart/form-data"
                        };
                    let configuration = {headers : header };
                    this.dialogLoadingUploadFile = true;  

                    let formData = new FormData();                   
                    //formData.append("id_doc", me.projectID_new);
                    formData.append("id_doc_det", item.id_doc_det);
                    //formData.append("id_flow", me.frmIdWorkflow);
                    

                   axios.post('api/dell_sop_d_document_detail/WorkflowStop',formData,configuration).then(function(response){                     
                        if (response.data.msg == 'Token no valid')
                        {
                            me.exitApp();
                        }                       
                         me.listCurrentProject();
                    }).catch(function(error){                     
                       console.log(error);
                    }).finally(() => this.dialogLoadingUploadFile  = false,                        
                    ); 
            },

                
            
            downloadPowerPoint(item){
                axios({
                    method: 'get',
                    url: item.sop[0].ppt_path,
                    responseType: 'arraybuffer'
                    //data: dates
                    }).then(function(response) {
                    let blob = new Blob([response.data], { type: 'application/pptx' })
                    let link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    link.download = 'Station_' + item.station_no + '.pptx'
                    link.click()
                    })
            },

            

            collectionsShow(item){
                this.dialogShowImages = true;
                this.stationCarrusel = item.station_no;
                this.itemsSOP = item.sop[0].imagesPath;
                this.model = 0;
                //console.log(this.itemsSOP);
            },
            collectionsHide(){
                this.dialogShowImages = false;
            },
            signaturesShow(item){
                this.dialogShowSignatures = true;
                this.stationSignatures = item.station_no;
                this.DetailsSignatures = item.sop[0].signList;                
            },
            signaturesHide(){
                this.dialogShowSignatures = false;
            },


            showContactList(){
                this.verContactos = 1;
                //console.log(this.verContactos);
            },
            hideContactList(){
                this.verContactos = 0;
            },
            showNew(){
                this.verNuevo = 1;   
                this.editedIndex = -1; 
                this.frmFlownameIsReadOnly = false;                    
                //console.log("show New");
            },
            hideNew(){
                this.verNuevo = 0;
                this.clean();               
            },
             exitApp(){
                this.$store.dispatch("exit");
            }, 
            findContact(){  
                console.log('Buscar contacto');
                let me=this;

                me.errorContact = null;

                let header={"Authorization": "Bearer " + this.$store.state.token};
                let configuration = {headers : header };
                let url='';
                url ='api/dell_sop_s_contact/BuscarContact/' + me.frmContactBadgeid;               
                axios.get(url,configuration).then(function(response){
                    //console.log(response);
                    me.addContact(response.data);
                    me.frmContactBadgeid = '';
                    //me.partnoAlt = response.data;
                }).catch(function(error){
                    console.log(error);

                    me.errorContact = 'Contact no exist';
                })
            }, 
            listContact(){
                let me=this;
                let header={"Authorization": "Bearer " + this.$store.state.token};
                let configuration = {headers : header };
                let url='';
                url ='api/dell_sop_s_contact/ListContact/' + me.texto;               
                axios.get(url,configuration).then(function(response){                   
                    me.contactos = response.data;
                }).catch(function(error){
                    console.log(error);
                })
            },
            addContact(data = []){
                this.errorContact = null;
                if (this.findDuplicate(data['id_contact'])){
                    this.errorContact = "Contact has already been added";
                }else{

                    var sendSequence = 0;
                    sendSequence  = this.DetailsContact.length +1;

                    this.DetailsContact.push(
                        {
                            id: data['id_contact']
                            ,sequence: sendSequence
                            ,contactType: this.frmContactType
                            ,badgeid: data['badgeid']
                            ,contactName: data['contactname']
                            ,email: data['email']
                        }
                    );
                }
            }, 
            findDuplicate(id){
                var sw = 0;
                for (var i=0; i < this.DetailsContact.length; i++){
                    if (this.DetailsContact[i].id == id){
                        sw = 1;
                    }
                }
                return sw;
            },
            deleteContact(arr, item){
                var sendSequence = 0;

                var i = arr.indexOf(item);
                if (i !== -1){
                    arr.splice(i,1);
                }

                for (var i=0; i < this.DetailsContact.length; i++){
                    sendSequence++
                    this.DetailsContact[i].sequence = sendSequence;

                }
            },          
          
            
            initialize () {                            
            },
            
            editItem (item) {
                                              
               
                
              
                this.id= item.id_flow;  
                this.frmFlowname= item.flowname; 
                
                
                this.projectID_new = item.id_doc;
                
                this.frmProjectName = item.sop_name;
                this.frmServiceTagPlaform = item.platform;
                this.frmServiceTagModel = item.model;
                this.frmIdArea = item.id_area;
                this.frmIdLinetype = item.id_line;
                this.frmIdWorkflow = item.id_flow;


                this.frmIdLob = item.id_lob;
                this.sopFiles = item.detail;
               
                 
                this.showNew();
               
                this.frmFlownameIsReadOnly = true;    
                this.editedIndex=1;
               
            },

            activeDesactiveItem (accion, item) {
                this.adModal= 1;
                this.adName = item.flowname;
                this.adId = item.id_flow;

                if (accion == 1){
                   this.adAccion = 1;
                } else if (accion == 2){
                    this.adAccion = 2;
                } else{
                   this.adModal= 0;
                }                
            },

            activateDesactivateClose(){
                this.adModal = 0;
            },

            activate(){
                let me=this;
                   let header={"Authorization": "Bearer " + this.$store.state.token};
                   let configuration = {headers : header };
                   axios.put('api/dell_sop_s_workflow_master/Activate/' + this.adId,{},configuration).then(function(response){
                        me.adModal =0;
                        me.adAccion = 0;
                        me.adName = "";
                        me.adId = "";                       
                        me.listWorkflow();                        
                    }).catch(function(error){                        
                        console.log(error);
                        this.errored = true;
                    }).finally(() => this.dialogLoading  = false);
            },
            deactivate(){
                let me=this;
                   let header={"Authorization": "Bearer " + this.$store.state.token};
                   let configuration = {headers : header };
                   axios.put('api/dell_sop_s_workflow_master/Desactivate/' + this.adId,{},configuration).then(function(response){
                        me.adModal =0;
                        me.adAccion = 0;
                        me.adName = "";
                        me.adId = "";                       
                        me.listWorkflow();                        
                    }).catch(function(error){                        
                        console.log(error);
                        this.errored = true;
                    }).finally(() => this.dialogLoading  = false);
            },

            close () {
                this.dialog = false;
                this.dialogLoading = false;
                this.clean();
            },            
            clean() {               

                this.frmFlownameIsReadOnly = true;   
                
                this.id= ""; 

                this.projectID_new= 0,
               

                this.frmIdWorkflow ="";                
                this.project_name ="";
                this.frmProjectName ="";
                this.frmServiceTagPlaform ="";
                this.frmServiceTagModel ="";
                this.frmIdLob ="";
                this.frmIdArea ="";
                this.frmIdLinetype ="";
                this.sopFiles= [],
                


               
                this.frmFlowname = "";                
                this.frmContactBadgeid = "";
                this.DetailsContact =[];

                this.contactname= "";
                this.email= "";
                this.condition= ""; 
                  
               
                this.editedIndex=-1;
                

                this.valida= 0;
                this.validaMensaje= [];

            },           
          
               save () {             

                console.log('SAVING...');
                if (this.validar() > 0)  {                                      
                     return;   
                }                 
                
                if (this.editedIndex > -1) {                   
                   //Code for Edit Mode
                  
                 
                  this.dialogLoading = true;
                   
                  let me=this;    
                    let header={
                        "x-token": this.$store.state.token,
                        "Authorization": "Bearer " + this.$store.state.token,
                        "Content-Type": "multipart/form-data"
                        };
                    let configuration = {headers : header };
                    this.dialogLoading = true;   

                    //me.projectID_new = me.id;

                    console.log('Update project: = ' + me.projectID_new);

                    let formData = new FormData();
                    formData.append("id_doc", me.projectID_new);                    
                    formData.append("platform", me.frmServiceTagPlaform);
                    formData.append("model", me.frmServiceTagModel);
                    formData.append("id_flow", me.frmIdWorkflow);  
                    formData.append("sop_name", me.frmProjectName);                          
                    formData.append("id_lob", me.frmIdLob);
                    formData.append("id_area", me.frmIdArea);
                    formData.append("id_line", me.frmIdLinetype);
                    
                    formData.append("details", me.sopFiles);
                   
                      console.log(me.sopFiles);
                   
                    
                   axios.post('api/dell_sop_d_document_master/UpdateDocument',formData,configuration).then(function(response){                      
                       // me.close();                       
                        //me.listInvoices();
                        //me.clean();

                        if (response.data.msg == 'Token no valid')
                        {
                            me.exitApp();
                        }
                        if (response.data.msg == 'duplicate')
                        {
                            me.verMessageBackend = 1;                            
                        }
                        me.listProject();
                    }).catch(function(error){                     
                       console.log(error);
                    }).finally(() => this.dialogLoading  = false,
                        //this.validaMensaje.push('Bom Upload.')
                    ); 
                                    

                } else {                    
                    //Code for Save                   
                  // if (this.validar()){
                   //    return;
                  // }                   

                   // axios.defaults.baseURL =  this.$hostname;
                    let me=this;    
                    let header={
                        "x-token": this.$store.state.token,
                        "Authorization": "Bearer " + this.$store.state.token,
                        "Content-Type": "multipart/form-data"
                        };
                    let configuration = {headers : header };
                    this.dialogLoadingSaveProject = true;   

                    let formData = new FormData();  
                    formData.append("id_flow", me.frmIdWorkflow);                
                    formData.append("sop_name", me.frmProjectName);
                    formData.append("platform", me.frmServiceTagPlaform);
                    formData.append("model", me.frmServiceTagModel);
                    formData.append("id_lob", me.frmIdLob);
                    formData.append("id_area", me.frmIdArea);
                    formData.append("id_line", me.frmIdLinetype);                   
                                          

                   this.projectID_new = 0;
                   console.log('Flow ID =',me.frmIdWorkflow ) ;              
                   axios.post('api/dell_sop_d_document_master/CreateDocument',formData,configuration).then(function(response){                      
                        //me.close();
                        me.projectID_new = response.data.projectID; 
                        //this.run_SAP(); 
                        //console.log('RETURN PROJECT ID = ' + me.projectID_new);                    
                        //me.listInvoices();
                        //me.clean();
                        if (response.data.msg == 'Token no valid')
                        {
                            me.exitApp();
                        }                       
                        if (response.data.msg == 'duplicate')
                        {
                            me.verMessageBackend = 1;                            
                        }
                    }).catch(function(error){                     
                       console.log(error);
                    }).finally(() => this.dialogLoadingSaveProject  = false,                        
                    ); 


                    //me.listInvoices();                 
                }               
            },

             validarNewStation() {
                 this.valida=0;
                 this.validaMensaje=[];
                 
                 if (!this.frmIdLob){
                     this.validaMensaje.push('Select  LOB.');
                 } 
                 if (!this.frmIdArea){
                     this.validaMensaje.push('Select Area.');
                 } 
                 if (!this.frmIdLinetype){
                     this.validaMensaje.push('Select Line type.');
                 } 
                 if (!this.frmIdWorkflow){
                     this.validaMensaje.push('Select Workflow.');
                 }   
                 
                 if (this.validaMensaje.length){
                    this.valida=1;                    
                }                                             
                 return this.valida;
            },
            validar() {
                 this.valida=0;
                 this.validaMensaje=[];
                 
                 
                 if (!this.frmProjectName){
                     this.validaMensaje.push('Input the project name.');
                 }   
                 if (!this.frmServiceTagPlaform){
                     this.validaMensaje.push('Platform empty, Get the plantform with serviceTag.');
                 } 
                 if (!this.frmServiceTagModel){
                     this.validaMensaje.push('Model empty, get the model with serviceTag.');
                 } 
                 if (!this.frmIdLob){
                     this.validaMensaje.push('Select the Lob.');
                 } 
                 if (!this.frmIdArea){
                     this.validaMensaje.push('Select the Area.');
                 }
                 if (!this.frmIdLinetype){
                     this.validaMensaje.push('Select the Line type.');
                 }   
                 if (!this.frmIdWorkflow){
                     this.validaMensaje.push('Select the Workflow.');
                 }  
                
                
                  
                 if (this.validaMensaje.length){
                    this.valida=1;                    
                }                                             
                 return this.valida;
            },
        },
    }
</script>